function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameHudTemplate = require('./game-hud.template');
var _require = require('./game-hud-types'),
  DESKTOP = _require.DESKTOP,
  MOBILE_PORTRAIT = _require.MOBILE_PORTRAIT,
  MOBILE_LANDSCAPE = _require.MOBILE_LANDSCAPE;

/**
 * The HUD is a general interface for users to interact with a (board) game
 * HUD is optimized for dynamically displaying user controls, and will (unless overridden) attempt to resize
 * in order to optimally fit the height and width of the menu options, by assuming developers follow certain
 * conventions about labeling cards, icons, or text menu lists for users to click on.
 * Other than rendering and attaching events in your Game_Module, you will primarily interact with GameHud
 * indirectly. GameTemplate includes two functions for nicely putting content into the GameHud--
 *
 * updateStatusAndListCards -- display a status message (prompt) and graphical depiction of cards
 * updateStatusWithOptions -- display a status message (prompt) and a list of text commands
 *
 * HUD vs PlayerBox. HUD is best when information about game state is available on the game board and we don't need persistent summaries of opponent statistics.
 * HUD is flexible for inserting different kinds of clickable options to interact with the game, and can be easily hidden to allow viewing of a possibly large/complex game board
 *
 *
 * GameHud is available in different modes -- vertical (along the left side of the screen)
 * or horizontal (along the bottom of the screen)
 *
 */
var GameHud = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param app - the Saito application
   * @param mod - the game module
   */
  function GameHud(app, mod) {
    _classCallCheck(this, GameHud);
    this.app = app;
    this.game_mod = mod;
    this.maxWidth = 0.5; //this.mode associated variable, ratio of view width for maximum display
    this.card_width = 150; //Maximum card width of 150px
    this.minWidth = 500; //num of pixels for minimum display width (dependent on this.mode) overwrite AFTER rendering
    this.auto_sizing = 1; //flag to automatically resize HUD based on its internal functions
    this.is_draggable = 1;
    this.enable_mode_change = 0; //flag to allow users to toggle between hud-long, hud-square and hud-vertical
    this.draggable_whole = true;
    this.hud_popup_timeout = null;
    this.back_button = false;
    this.back_button_callback = null;
    this.back_button_clicked = false;
    this.zIndex = 1;
    this.mode = 0; // 0 wide (HUD-long)
    // 1 classic (HUD-square)
    // 2 vertical
    this.lastPosition = ''; //Remember where the hud was if toggling to hide offscreen
    this.respectDocking = false;

    //
    // variables used to keep status centered in hud
    // as the hud resizes when cards change. we calculate
    // new widths and use older data to inch HUD along so
    // the status stays centered in place as the HUD is
    // redrawn.
    //

    this.user_dragged = 0;
    this.cached_status_header_height_inclusive = 50; //default to 50px (40px height + 10px margin)

    this.cards_currently_displayed = -1;
    this.status_left = -1;
    this.status_width = -1;
    this.hud_left = -1;
    this.hud_width = -1;
    this.lock_interface = false;
    this.timers = [];
    this.display_queue = [];
    this.debugging = false;
  }
  return _createClass(GameHud, [{
    key: "render",
    value: function render() {
      //Needed for game engine to know to call HUD's internal updateStatus instead of basic updateStatus
      this.game_mod.useHUD = 1;
      if (!this.game_mod.browser_active == 1) {
        return;
      }
      if (!document.querySelector('#hud')) {
        this.app.browser.addElementToDom(GameHudTemplate(this.enable_mode_change));
      }
      var hud = document.querySelector('#hud');
      if (this.mode >= 0 && this.mode <= 2) {
        hud.className = 'hud'; //Remove additional class names
        hud.removeAttribute('style'); //Remove all inline styling
      }
      var deviceType = this.checkSizeAndOrientation();
      switch (this.mode) {
        case 0:
          hud.classList.add('hud-long');
          hud.classList.add('hide-scrollbar');
          this.maxWidth = deviceType == MOBILE_PORTRAIT ? 1 : 0.8;
          this.minWidth = 500;
          hud.style.top = '';
          break;
        case 1:
          hud.classList.add('hud-square');
          hud.classList.add('hide-scrollbar');
          this.maxWidth = 0.4;
          this.minWidth = 400;
          break;
        case 2:
          hud.classList.add('hud-vertical');
          this.maxWidth = 0.2;
          this.minWidth = 240;
          break;
        default:
          console.error('Undefined HUD Mode');
          this.auto_sizing = false;
      }
      if (this.auto_sizing) {
        var dockStatus = this.respectDocking;
        this.respectDocking = true;
        this.respectDocking = dockStatus;
      }
      hud.style.display = 'block';
      hud.style.zIndex = this.zIndex;
      this.attachEvents();
    }

    /**
     * HUD events:
     *    1) HUD can be dragged by the user to a new position
     *    2) HUD can be minimized/restored by clicking on an icon in its top right corner
     *    3) HUD mode can be toggled between available display modes (optional, requires changing the this.enable_mode_change property)
     * @param app - the Saito application
     * @param game_mod - the containing game module
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var myself = this;
      try {
        if (this.is_draggable) {
          // hud is draggable
          var drag_handle = this.draggable_whole ? 'hud' : 'hud-header';
          this.app.browser.makeDraggable('hud', drag_handle, true, function () {
            _this.user_dragged = 1;
            try {
              var hud = document.querySelector('.hud');
              var status = document.querySelector('.status-header');
              _this.status_left = hud.style.left;
              _this.status_top = hud.style.top;
              _this.status_width = hud.style.width;
              _this.hud_left = hud.style.left;
              _this.hud_top = hud.style.top;
              _this.hud_width = hud.offsetWidth;
            } catch (err) {}
            document.querySelector('.hud').classList.add('user_dragged');
          });
        }
      } catch (err) {
        console.log('HUD Events:', err);
      }
      // hud is minimizable
      try {
        var hud_toggle_button = document.getElementById('hud-toggle-button');
        if (hud_toggle_button) {
          hud_toggle_button.onclick = function (e) {
            e.stopPropagation();
            myself.toggleHud();
          };
        }
      } catch (err) {
        console.error('HUD Events:', err);
      }

      //cycle through hud modes
      try {
        var hud_mode_button = document.getElementById('hud-mode-button');
        if (hud_mode_button) {
          hud_mode_button.onclick = function (e) {
            e.stopPropagation();
            myself.mode++;
            if (myself.mode > 2) {
              myself.mode = 0;
            }
            //myself.cards_currently_displayed = -5; // force recalculation of sizing
            myself.render();
          };
        }
      } catch (err) {
        console.error('HUD Events:', err);
      }
      if (document.querySelector('.hud-notice')) {
        document.querySelector('.hud-notice').onclick = function (e) {
          _this.hidePopup();
        };
      }
    }

    /**
     * (completely) hide Hud from the DOM
     */
  }, {
    key: "hide",
    value: function hide() {
      try {
        document.getElementById('hud').style.display = 'none';
      } catch (err) {}
    }
  }, {
    key: "updateStatus",
    value: function updateStatus(msg) {
      var _this2 = this;
      if (this.back_button == true && this.back_button_callback != null) {
        this.back_button_clicked = false;
        msg = "<div class=\"back-button\">".concat(this.game_mod.back_button_html, "</div>").concat(msg);
      } else {
        msg = "<div class=\"back-button\" style=\"display:none;\">".concat(this.game_mod.back_button_html, "</div>").concat(msg);
      }
      if (document.querySelector('.hud-body .status')) {
        document.querySelector('.hud-body .status').innerHTML = msg;
      }
      if (document.querySelector('.hud-body .status .back-button')) {
        document.querySelector('.hud-body .status .back-button').onclick = function (e) {
          _this2.back_button_clicked = true;
          _this2.back_button_callback();
        };
      }
    }
  }, {
    key: "updateControls",
    value: function updateControls(msg) {
      if (document.querySelector('#hud .controls')) {
        document.querySelector('#hud .controls').innerHTML = msg;
      }
    }

    //
    // regardless of whether we display CARDS (graphics) or OPTIONS (text)
    // we want to trigger the ability for users to click on the card and
    // have the ID submitted to the function provided. This takes care of
    // that issue, using the cardbox as needed.
    //
  }, {
    key: "attachControlCallback",
    value: function attachControlCallback() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.game_mod.useCardbox) {
        this.game_mod.changeable_callback = mycallback;
        this.game_mod.cardbox.hide(1);
        this.game_mod.cardbox.attachCardEvents();
      }
      document.querySelectorAll('.controls ul li.option').forEach(function (opt) {
        opt.onclick = function (e) {
          document.querySelectorAll('.controls ul li.option').forEach(function (opt) {
            opt.onclick = function (evt) {};
            try {
              opt.remove();
            } catch (err) {}
          });
          var id = e.target.getAttribute('id');
          mycallback(id);
        };
      });
    }
  }, {
    key: "setInterfaceLock",
    value: function setInterfaceLock() {
      var _this3 = this;
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.lock_interface = true;
      this.game_mod.gaming_active = 1;
      this.timers.push(setTimeout(function () {
        _this3.timers.shift();
        if (_this3.timers.length == 0) {
          _this3.game_mod.gaming_active = 0;
          _this3.lock_interface = false;
          if (_this3.display_queue.length > 0) {
            _this3.updateStatus(_this3.display_queue.pop());
          }
          if (callback) {
            callback();
          }
        }
      }, 1000));
    }
  }, {
    key: "insertCard",
    value: function () {
      var _insertCard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(card_html) {
        var callback,
          hudCards,
          elm,
          timeout,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              callback = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
              hudCards = document.querySelector('.status-cardbox');
              if (hudCards) {
                _context.n = 1;
                break;
              }
              console.warn('HUD: insert card failure');
              return _context.a(2);
            case 1:
              this.app.browser.addElementToId(card_html, 'status-cardbox');
              elm = hudCards.lastElementChild;
              if (!callback) {
                _context.n = 3;
                break;
              }
              timeout = function timeout(ms) {
                return new Promise(function (res) {
                  return setTimeout(res, ms);
                });
              };
              this.setInterfaceLock(callback);
              elm.style.opacity = 1;
              _context.n = 2;
              return timeout(150);
            case 2:
              elm.classList.add('flipped');
              _context.n = 3;
              return timeout(350);
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function insertCard(_x) {
        return _insertCard.apply(this, arguments);
      }
      return insertCard;
    }()
    /**
     * Implement the toggle (slide on/offscreen) to minimize and restore HUD from display
     */
  }, {
    key: "toggleHud",
    value: function toggleHud() {
      var hud = document.getElementById('hud');
      var hudToggle = document.getElementById('hud-toggle-button');
      if (!hud || !hudToggle) {
        console.error("Couldn't find HUD elements");
        return;
      }
      hudToggle.classList.toggle('fa-caret-up');
      hudToggle.classList.toggle('fa-caret-down');
      if (hudToggle.classList.contains('fa-caret-up')) {
        //I am minimized
        this.lastPosition = getComputedStyle(hud).top;
        hud.style.top = "".concat(window.innerHeight - 20, "px");
        hud.style.marginTop = 'unset'; //For HUD - vertical, the margin to push it under the menu
        /*hud.style.background = "#222d";*/
      } else {
        //I am restored
        hud.style.top = this.lastPosition;
        hud.style.paddingTop = '';
        hud.style.background = '';
      }
    }
  }, {
    key: "hidePopup",
    value: function hidePopup() {
      var hudnotice = document.querySelector('.hud-notice');
      if (hudnotice) {
        hudnotice.classList.remove('show');
        //hudnotice.innerHTML = '';
        setTimeout(function () {
          hudnotice.style.display = 'none';
        }, 550);
      }
      clearTimeout(this.hud_popup_timeout);
    }
  }, {
    key: "showPopup",
    value: function showPopup() {
      var _this4 = this;
      var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var hudnotice = document.querySelector('.hud-notice');
      if (hudnotice) {
        hudnotice.innerHTML = html;
        hudnotice.style.display = 'block';
        setTimeout(function () {
          hudnotice.classList.add('show');
          _this4.hud_popup_timeout = setTimeout(function () {
            _this4.hidePopup();
          }, timeout);
        }, 50);
      }
    }

    /**
     * Internal function to determines view window (Desktop, mobile landscape or mobile portrait)
     *
     */
  }, {
    key: "checkSizeAndOrientation",
    value: function checkSizeAndOrientation() {
      if (window.matchMedia('(orientation: landscape)').matches && window.innerHeight <= 600) {
        return MOBILE_LANDSCAPE;
      }
      if (window.matchMedia('(orientation: portrait)').matches && window.innerWidth <= 600) {
        return MOBILE_PORTRAIT;
      }
      return DESKTOP;
    }
  }]);
}();
module.exports = GameHud;